export function calcNextSortOrder(items, parentKey, parentId) {
  const scope = parentKey
    ? items.filter((i) => (i[parentKey] ?? null) === (parentId ?? null))
    : items;
  if (!scope.length) return 1;
  return Math.max(...scope.map((i) => i.sort_order ?? 0)) + 1;
}

export function filterByKeyword(items, keyword) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return items;
  return items.filter(
    (i) =>
      (i.name_zh || '').toLowerCase().includes(kw)
      || (i.name_my || '').toLowerCase().includes(kw)
  );
}

export const MAX_MAIN_CATEGORY_KEYBOARD = 16;
export const MAX_SUB_CATEGORY_KEYBOARD = 16;
/** 小分类 TOP 榜最多 6 个（2×3） */
export const MAX_TOP_RANK = 6;
/** @deprecated 使用 MAX_MAIN_CATEGORY_KEYBOARD */
export const MAX_CATEGORY_KEYBOARD = MAX_MAIN_CATEGORY_KEYBOARD;

export function sortByOrder(items, asc = true) {
  const sorted = [...items].sort((a, b) => {
    const diff = (a.sort_order ?? 0) - (b.sort_order ?? 0);
    if (diff !== 0) return diff;
    return a.id - b.id;
  });
  return asc ? sorted : sorted.reverse();
}

/** ISO / Date → 本地时间 YYYY-MM-DD HH:mm:ss */
export function formatDateTime(val) {
  if (!val) return '-';
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return String(val);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
